import directive from './directives'
import auth, {has} from './auth'
import clickOutside from './click-outside'

const importDirective = Vue => {
  /**
   * 拖拽指令 v-draggable="options"
   * options = {
   *  trigger: /这里传入作为拖拽触发器的CSS选择器/,
   *  body:    /这里传入需要移动容器的CSS选择器/,
   *  recover: /拖动结束之后是否恢复到原来的位置/
   * }
   */
  Vue.directive('draggable', directive.draggable)
  Vue.directive('auth', auth)
  // 按钮级的权限控制，这里是为了和v-if配置使用（推荐）
  Vue.prototype.$has = has
  Vue.directive('click-outside', clickOutside)
}

export default importDirective



// WEBPACK FOOTER //
// ./src/directive/index.js